export const UPLOAD_MEDIA_REQUEST = "UPLOAD_MEDIA_REQUEST";
export const UPLOAD_MEDIA_SUCCESS = "UPLOAD_MEDIA_SUCCESS";
export const UPLOAD_MEDIA_FAIL = "UPLOAD_MEDIA_FAIL";

export const UPLOAD_MEDIA_ALL_REQUEST = "UPLOAD_MEDIA_ALL_REQUEST";
export const UPLOAD_MEDIA_ALL_SUCCESS = "UPLOAD_MEDIA_ALL_SUCCESS";
export const UPLOAD_MEDIA_ALL_FAIL = "UPLOAD_MEDIA_ALL_FAIL";

export const DOWNLOAD_MEDIA_REQUEST = "DOWNLOAD_MEDIA_REQUEST";
export const DOWNLOAD_MEDIA_SUCCESS = "DOWNLOAD_MEDIA_SUCCESS";
export const DOWNLOAD_MEDIA_FAIL = "DOWNLOAD_MEDIA_FAIL";